import ReactPixel from 'react-facebook-pixel';

export const initializeFacebookPixel = () => {
    const pixelId = '1769898287182670';
    ReactPixel.init(pixelId);
    ReactPixel.pageView();
}

export const trackEvent = (event) => {
    ReactPixel.track(event);
}